module.exports = __webpack_public_path__ + "static/media/purplePlus.39e9bd7a.svg";